




























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { ResourceHelper } from "@/helper/resourceHelper"
import { FontManager } from '@/model/fontManager/fontManager';
import { DebugHelper } from "@/helper/debugHelper";

import * as def from "@/definitions";
@Component({
  components: {}
})
export default class DropdownList extends Vue {
    // タグ
    @Prop() tag!: string;

    // リストアイテム
    @Prop() private items!: Array<{
        id: number;
        label: string;
        image: string;
        isSelected: boolean;
        isSelecting : boolean;
        fontId : string | null;
    }>;
    @Watch('items') itemsChanged()
    {
        this.innerItems = this.items.slice();
    }

    private innerItems : Array<{
        id: number;
        label: string;
        image: string;
        isSelected: boolean;
        isSelecting : boolean;
        fontId : string | null;
    }> = [];

    mounted() 
    {
        this.innerItems = this.items.slice();
        document.addEventListener("keydown", this.onKeyDown);  
        this.$store.getters.applicationState.dropdownListMode = 1;
        this.$nextTick(() => this.adjustScroll());
    }

    destroyed() 
    {
        document.removeEventListener("keydown", this.onKeyDown);
        this.$store.getters.applicationState.dropdownListMode = 0;    
    }

    private onKeyDown(e : KeyboardEvent)
    {
        if(e.key == "ArrowDown")
        {
            // 下
            // 今選択中のリスト項目を一つ下へ移動する
            // 選択がない場合は一番上を選択する
            e.preventDefault();

            let itemsCopy = this.innerItems.slice();
            let isDone = false;
            for(let i = 0; i < itemsCopy.length; ++i)
            {
                let item = itemsCopy[i];
                let nextItem = i + 1 < itemsCopy.length ? itemsCopy[i + 1] : itemsCopy[0];
                if(item.isSelecting)
                {
                    item.isSelecting = false;
                    nextItem.isSelecting = true;
                    isDone = true;
                    break;
                }
            }
            if(!isDone && itemsCopy.length > 0)
            {
                itemsCopy[0].isSelecting = true;
            }
            this.innerItems = itemsCopy;
            this.adjustScroll();
        }
        else if(e.key == "ArrowUp")
        {
            // 上
            // 今選択中のリスト項目を一つ上へ移動する
            // 選択がない場合は一番下を選択する
            e.preventDefault();

            let items = this.innerItems.slice();
            let isDone = false;
            for(let i = items.length - 1; i >= 0; --i)
            {
                let item = items[i];
                let prevItem = i - 1 >= 0 ? items[i - 1] : items[items.length - 1];
                if(item.isSelecting)
                {
                    item.isSelecting = false;
                    prevItem.isSelecting = true;
                    isDone = true;
                    break;
                }
            }
            if(!isDone && items.length > 0)
            {
                items[items.length - 1].isSelecting = true;
            }
            this.innerItems = items;
            this.adjustScroll();
        }
        else if(e.key == "Enter")
        {
            // 選択中の項目があれば決定する
            for(let i = 0; i < this.innerItems.length; ++i)
            {
                let item = this.innerItems[i];
                if(item.isSelecting)
                {
                    this.onClick(item.id);
                    e.preventDefault();
                    break;
                }
            }
        }
    }

    adjustScroll()
    {
        let list = this.$refs.list as HTMLElement;
        if(list == null) return;

        // 選択項目のY座標
        // selectingを優先。ない場合はselected
        let selectingIndex = -1;
        let selectedIndex = -1
        for(let i = 0; i < this.innerItems.length; ++i)
        {
            if(this.innerItems[i].isSelecting) selectingIndex = i;
            if(this.innerItems[i].isSelected) selectedIndex = i;
        }
        let targetIndex = selectingIndex >= 0 ? selectingIndex : selectedIndex;
        if(targetIndex < 0) return;
        const itemHeight = 24;
        const padding = 8;
        let targetItemY = targetIndex * itemHeight + padding;
        // 表示されているYの範囲
        let topY = list.scrollTop;
        let bottomY = topY + list.clientHeight;
        if(targetItemY < topY)
        {
            // 上方向が隠れているので、スクロール位置を補正する
            DebugHelper.trace("adjust scroll");
            list.scrollTop = targetItemY;
            DebugHelper.trace(list.scrollTop);
        }
        else if(targetItemY + itemHeight > bottomY)
        {
            // 下方向が隠れているので、スクロール位置を補正する
            DebugHelper.trace("adjust scroll");
            list.scrollTop += (targetItemY + itemHeight - bottomY);
        }
    }

    private close() {
        this.$emit("close");
    }

    private onClick(id) {
        // 通知
        this.$emit("select", id, this.tag);
    }

    getResource(file : string){
            return ResourceHelper.getResource(file);
        }

    getlistItemStyle(item)
    {
        if(item.isSelected)
            return this.selected;
        else if(item.isSelecting)
            return this.selecting;
        return this.unSelected;
    }

    get selected(){
        return {
            'background-color' : this.$store.getters.userConfigColors.buttonColorCode,
            'color' : '#ffffff'
        }
    }

    get selecting(){
        return {
            'background-color' : "#2476bc38",
            'color' : this.$store.getters.userConfigColors.textAColor
        }
    }

    get unSelected(){
        return {
            'color' : this.$store.getters.userConfigColors.textAColor
        }
    }

    private getTextStyle(fontId : string | null)
    {
        if(fontId == null) { return {}; }
        return {
            'font-family' : this.getFontFamily(fontId),
            'font-weight' : this.getFontWeight(fontId),
            'text-align' : this.tag == "fontId" ? 'left' : "center"
        };
    }

    private getFontFamily(fontId : string)
    {
        var fontManager : FontManager = this.$store.getters.fontManager;
        return fontManager.getFontFamilyName(fontId);
    }

    private getFontWeight(fontId : string) : string
    {
        var fontManager : FontManager = this.$store.getters.fontManager;
        var font = fontManager.getFontFamilyById(fontId);
        if(font.weight == null) { return "normal"; }
        return font.weight.toString();
    }
}
